<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Tìm kiếm">
          <div slot="content">
            <div class="form-group col-md-4 col-sm-6 col-xs-12">
              <label>Công ty</label>
              <multiselect v-model="selectedCompany" id="ajax" label="name" track-by="code"
                           placeholder="Nhập để tìm công ty..."
                           open-direction="bottom" :options="companies" :multiple="false" :searchable="true"
                           :loading="loadingCompany" :internal-search="false" :clear-on-select="false"
                           :close-on-select="true" :options-limit="300" :limit="2" :max-height="600"
                           :show-no-results="false" :hide-selected="false" @search-change="debounceCompany">
              </multiselect>
            </div>
            <div class="form-group col-md-4 col-sm-6 col-xs-12">
              <label>Hạn thanh toán từ ngày</label>
              <date-picker v-model="filterData.from_date" valueType="format"></date-picker>
            </div>
            <div class="form-group col-md-4 col-sm-6 col-xs-12">
              <label>Đến ngày</label>
              <date-picker v-model="filterData.to_date" valueType="format"></date-picker>
            </div>
          </div>
          <div slot="footer">
            <div class="d-flex justify-content-end align-items-center ">
              <b-button class="mr-2" variant="primary" v-b-tooltip.hover title="Tổng kết chi phí"
                        @click="calculatePayment()">
                Tổng kết chi phí
              </b-button>
              <b-button variant="warning" @click="search">
                <span class="glyphicon glyphicon-search" aria-hidden="true"></span> Tìm kiếm
              </b-button>
            </div>
          </div>
        </va-box>
      </div>

      <div class="col-md-12 col-sm-12 col-xs-12" style="font-size: 12px!important;">
        <va-box theme="box-primary" title="Danh sách công ty sử dụng tổng đài">
          <div slot="content">
            <b-table responsive    bordered outlined hover :busy="loading" :fields="fields" :items="items"
                     show-empty>
              <template #table-busy>
                <div class="text-center my-2 mt-5 mb-5">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Đang tải...</strong>
                </div>
              </template>

              <template #empty="scope">
                <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
              </template>

              <template v-slot:cell(is_enable)="dataId">
                <b-form-checkbox v-model="dataId.item.is_enable" switch size="lg"
                                 @change="updateStatus(dataId.item)"></b-form-checkbox>
              </template>
              <template v-slot:cell(agent_fee)="dataId">
                {{dataId.item.agent_fee | format_currency}}
              </template>
              <template v-slot:cell(external_fee)="dataId">
                {{dataId.item.external_fee | format_currency}}
              </template>
              <template v-slot:cell(credit_payment_amount)="dataId">
                {{dataId.item.credit_payment_amount | format_currency}}
              </template>
              <template v-slot:cell(external_payment_amount)="dataId">
                {{dataId.item.external_payment_amount | format_currency}}
              </template>
              <template v-slot:cell(total_payment_amount)="dataId">
                {{dataId.item.total_payment_amount | format_currency}}
              </template>

              <template v-slot:cell(discount_type)="dataId">
                {{ dataId.item.discount_type === 'VALUE' ? 'Giá trị' : 'Phần trăm' }}
              </template>

              <template v-slot:cell(minute_fee)="dataId">
                <div>
                  <b-badge pill variant="secondary">Viettel: {{ dataId.item.minute_fee.Viettel | format_currency }}</b-badge>
                </div>
                <div>
                  <b-badge pill variant="secondary">Mobiphone: {{ dataId.item.minute_fee.Mobi | format_currency}}</b-badge>
                </div>
                <div>
                  <b-badge pill variant="secondary">Vinaphone: {{ dataId.item.minute_fee.Vina | format_currency}}</b-badge>
                </div>
              </template>

              <template v-slot:cell(actions)="dataId">
                <b-button variant="success" v-b-tooltip.hover title="Xác nhận thanh toán"
                          :disabled="dataId.item.payment_status === 'PAID'"
                          @click="requestPayment(dataId.item)">
                  {{ dataId.item.payment_status === 'PAID' ? 'Đã thanh toán' : 'Thanh toán' }}
                </b-button>
              </template>

            </b-table>
          </div>
          <div slot="footer" class="d-flex align-items-center justify-content-between">
            <div class="page-size-container">
              <span>Hiển thị</span>
              <b-form-select
                id="pageSize"
                v-model="pageSize"
                :options="pageSizes"
                required
              ></b-form-select>
              <span>  dòng</span>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRow"
              :per-page="pageSize"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </va-box>
      </div>

      <b-modal size='xl' id="submitPaymentStatusModal" hide-footer title="Xác nhận thanh toán"
               @hide="closeSubmitPaymentStatusModal">
        <div class="form-group col-md-12 col-sm-12 col-xs-12">
          <label>Gia hạn ngày thanh toán<span class="error-symbol"></span></label>
          <date-picker v-model="callCenterInfo.payment_date" valueType="format"></date-picker>
        </div>
        <div class="form-group col-md-12 col-sm-12 col-xs-12">
          <label>Gia hạn ngày nhắc hạn<span class="error-symbol"></span></label>
          <date-picker v-model="callCenterInfo.payment_notify" valueType="format"></date-picker>
        </div>
        <div class="form-group col-md-12 col-sm-12 col-xs-12">
          <label>Gia hạn ngày bắt đầu tính tiền<span class="error-symbol"></span></label>
          <date-picker v-model="callCenterInfo.payment_start_date" valueType="format"></date-picker>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="pull-right mt-3">
            <b-button variant="success" class="w-150px" @click="submitPayment">Xác nhận thanh toán</b-button>
          </div>
        </div>
      </b-modal>
    </section>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import DatePicker from 'vue2-datepicker'
import {debounce} from 'lodash'
import CompanyAPI from '../../api/company'
import Utils from '../../common/utils'
import CallCenterApi from '../../api/callCenter'
import Multiselect from '../../lib/vue-multiple-select/Multiselect'
import moment from 'moment'

export default {
  name: 'CallCenterListManagement',
  components: {
    'va-box': VABox,
    DatePicker,
    Multiselect
  },
  data () {
    return {
      filterData: {
        company_id: null,
        from_date: null,
        to_date: null
      },
      company: null,
      items: [],
      fields: [
        {
          key: 'id',
          label: 'ID',
          thStyle: 'width: 50px',
        },
        {
          key: 'company_name',
          label: 'Công ty',
          thStyle: 'width: 150px',
          thClass: 'text-center',
          tdClass: 'text-left'
        },
        {
          key: 'agent_fee',
          label: 'Phí theo Agent',
          thStyle: 'width: 150px',
          thClass: 'text-center',
          tdClass: 'text-right'
        },
        {
          key: 'charge_by',
          label: 'Thanh toán bởi',
          thClass: 'text-center',
          thStyle: 'width: 50px'
        },
        {
          key: 'discount_type',
          label: 'Loại khuyến mãi',
          thClass: 'text-center',
          thStyle: 'width: 50px'
        },
        {
          key: 'discount_value',
          label: 'Giá trị khuyến mãi',
          thStyle: 'width: 120px',
          thClass: 'text-center',
          class: 'text-right'
        },
        {
          key: 'external_fee',
          label: 'Phí ngoại mạng',
          thStyle: 'width: 120px',
          thClass: 'text-center',
          class: 'text-right'
        },
        {
          key: 'minute_fee',
          label: 'Phí theo sip phút',
          thClass: 'text-center',
          thStyle: 'width: 50px'
        },
        {
          key: 'payment_date',
          label: 'Hạn cần thanh toán',
          thClass: 'text-center',
          thStyle: 'width: 150px'
        },
        {
          key: 'payment_method',
          label: 'Thanh toán',
          thClass: 'text-center',
          thStyle: 'width: 50px'
        },
        {
          key: 'payment_notify',
          label: 'Ngày nhắc hạn',
          thClass: 'text-center',
          thStyle: 'width: 50px'
        },
        {
          key: 'sip_fee_calculation',
          label: 'Hình thức tính sip phút',
          thClass: 'text-center',
          thStyle: 'width: 50px'
        },
        {
          key: 'credit_payment_amount',
          label: 'Tổng cước trả sau',
          thStyle: 'width: 120px',
          thClass: 'text-center',
          class: 'text-right'
        },
        {
          key: 'external_payment_amount',
          label: 'Tổng cước ngoại mạng',
          thStyle: 'width: 120px',
          thClass: 'text-center',
          class: 'text-right'
        },
        {
          key: 'total_payment_amount',
          label: 'Tổng tiền cần thanh toán',
          thStyle: 'width: 120px',
          thClass: 'text-center',
          class: 'text-right'
        },
        {
          key: 'is_enable',
          label: 'Trạng thái',
          thClass: 'text-center',
          thStyle: 'width: 50px'
        },
        {
          key: 'actions',
          label: 'Tuỳ chọn',
          thStyle: 'width: 180px',
          thClass: 'text-center',
          class: 'text-center'
        }
      ],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      loadingCompany: false,
      companies: [],
      selectedCompany: null,
      debounceCompany: null,
      currentCompanyCallCenter: null,
      callCenterInfo: {
        company_id: null,
        payment_start_date: null,
        payment_date: null,
        payment_notify: null,
      },
      extFile: null
    }
  },
  created () {
    this.debounceCompany = debounce(this.filterCompany.bind(this), 500)
  },
  mounted () {
    this.filter()
    this.filterCompany()
  },
  methods: {
    calculateFilterData () {
      this.filterData.company_id = this.selectedCompany ? this.selectedCompany.code : null
    },
    search () {
      this.filter()
    },
    filter () {
      if (this.loading) {
        return
      }
      this.calculateFilterData()
      this.loading = true
      CallCenterApi.filter_call_center(this.filterData, this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    filterCompany (query) {
      this.loadingCompany = true
      CompanyAPI.findByName(query, 0, 20).then(res => {
        this.companies = res.data.data.records.map(item => {
          return {'name': item.name, 'code': item.id}
        })
        this.loadingCompany = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingCompany = false
      })
    },
    updateStatus (data) {
      CallCenterApi.updateStatus(data.is_enable, data.company_id).then(res => {
        if (res != null && res.data != null) {
          Utils.successToast(this.$bvToast)
          this.filter()
        }
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
      })
    },
    requestPayment (companyCallCenter) {
      this.currentCompanyCallCenter = companyCallCenter
      this.callCenterInfo.company_id = companyCallCenter.company_id
      this.callCenterInfo.payment_start_date = moment(companyCallCenter.payment_start_date).add(1, 'month').format('yyyy-MM-DD')
      this.callCenterInfo.payment_date = moment(companyCallCenter.payment_date).add(1, 'month').format('yyyy-MM-DD')
      this.callCenterInfo.payment_notify = moment(companyCallCenter.payment_notify).add(1, 'month').format('yyyy-MM-DD')
      this.$bvModal.show('submitPaymentStatusModal')
    },
    openImportExtModal (companyCallCenter) {
      this.currentCompanyCallCenter = companyCallCenter
      this.$bvModal.show('importExtModal')
    },
    closeSubmitPaymentStatusModal () {
      this.filter()
    },
    submitPayment () {
      this.callCenterInfo.payment_status = 'PAID'
      CallCenterApi.update_callcenter(this.callCenterInfo).then(res => {
        if (res != null && res.data != null) {
          Utils.successToast(this.$bvToast)
        }
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
      })
    },
    calculatePayment () {
      this.$bvModal.msgBoxConfirm('Tính toán lại chi phí cho tất cả?', {
        title: false,
        buttonSize: 'sm',
        centered: true,
        size: 'md',
        footerClass: 'p-2'
      }).then(res => {
        if (res) {
          CallCenterApi.calculatePayment().then(res => {
            Utils.successToast(this.$bvToast)
            this.filter()
          }).catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/call_center/CallCenterListManagement.vue